export default __webpack_public_path__ + "static/media/personalization.f9e97bd6.svg";